/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Crop_Region_LabelInputs */



/**
* | output |
* | --- |
* | "Scan Region" |
*
* @param {Ocr_Crop_Region_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_crop_region_label = /** @type {((inputs?: Ocr_Crop_Region_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Crop_Region_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Zone de numérisation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Scanbereich")
	if (locale === "it") return /** @type {LocalizedString} */ ("Regione di scansione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Область сканирования")
	if (locale === "es") return /** @type {LocalizedString} */ ("Región de escaneo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("扫描区域")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スキャン領域")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्कैन क्षेत्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Região de digitalização")
	return /** @type {LocalizedString} */ ("Scan Region")
});